import React from 'react';
import './OrderItem.scss';
import FormattedPrice from '../../../../components/FormattedPrice';
import {getItemPrice} from '../../../../helpers/common';

const OrderItem = ({item, t}) => {
  return (
    <div className={ 'order-item-info-web-pay' }>
      <div className={ 'info-block' }>
        <div className={ 'parent-item-info' }>
          <div className={ 'item-info-block' }>
            <div className={ 'item-name' }>{item.menuItem.item_name}</div>
            {/*<div className={ 'item-description' }>{item.menuItem.details_txt}</div>*/}
            <div className={ 'instructions' }>
              {
                item.instructions.map((instruction, index) => (
                  <div className={ 'instruction' }>
                    {instruction.menuItem.item_name}
                  </div>
                ))
              }

            </div>
            {item.freeInstruction && (
              <div className={ 'free-instruction-block' }>
                <div className={ 'free-instruction' }>
                  {item.freeInstruction}
                </div>
              </div>
            )}

            { item.orderItem.discount > 0 && (
                <div className={ 'discount' }>
                  <div className={ 'discount-label' }>{t('web_pay.invoice.discount')}</div>
                  <div>{item.orderItem.discount / 100}%</div>
                </div>
            )}

          </div>

          <div className={ 'item-quantity-info-block' }>
            <div className={ 'item-quantity-info' }>x {item.orderItem.quantity}</div>
          </div>

          <div className={ 'item-price-block' }>
            <div className={ 'item-price' }>
              <FormattedPrice price={ getItemPrice(item, false) } />
            </div>
          </div>
        </div>

        {item.supplements.map(supplement => (
          <div className={ 'item-supplement-info' }>
            <div className={ 'item-info-block' }>
              <div className={ 'item-name' }>
                <span>{supplement.menuItem.item_name}</span>
              </div>
            </div>

            <div className={ 'item-quantity-info-block' }>
              <div className={ 'item-quantity-info' }>x {supplement.orderItem.quantity}</div>
            </div>

            <div className={ 'item-price-block' }>
              <div className={ 'item-price' }>
                <FormattedPrice price={ getItemPrice(supplement, false) } />
              </div>
            </div>
          </div>
        ))}

      </div>
    </div>
  );
};

export default OrderItem;
